<template>
  <div class="mytaskList">
    <div>
      <p class="tipMsg">温馨提示：</p>
      <p class="tipMsg">
        ⚑标记“执行 打✔ ”：表示任务执行但并不一定是整个任务执行完成，可以
        是执行了其中一部分，具体说明在“执行情况”文本框填写即可。
      </p>
      <p class="tipMsg">
        ⚑标记“未执行 不打✔
        ”：表示整个任务都没有执行，具体说明在“执行情况”文本框填写即可。没有执行完的部分建议根据自己的实际情况登记到第二天的早会或者其他时间的早会处理。
      </p>
    </div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item>
        <el-select
          v-model="searchForm.is_own"
          size="small"
          style="width: 200px"
          placeholder="与我相关or所有"
        >
          <el-option label="所有早晚会任务" value="" />
          <el-option value="1" label="与我相关的早晚会任务" />
        </el-select>
      </el-form-item>
      <el-form-item label="会议主题">
        <el-input
          v-model="searchForm.meeting_name"
          clearable
          size="small"
          style="width: 300px"
          placeholder="会议主题"
        />
      </el-form-item>
      <el-form-item label="会议时间">
         <el-date-picker
          v-model="searchForm.time"
          size="small"
          type="daterange"
          align="right"
          unlink-panels
          :default-value="Date.now() - 30 * 24 * 3600 * 1000"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="会议编号">
        <el-input
          v-model="searchForm.meeting_id"
          style="width: 120px"
          clearable
          size="small"
          placeholder="会议编号"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          icon="el-icon-search"
          type="primary"
          @click="searchTap()"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <task-info
      :visible="drawer"
      :task-data="taskData"
      :log-list="logList"
      :active-label="activeLabel"
      @cancel="cancel"
      @searchFormSubmit="searchFormSubmit()"
    />
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="'草稿 (' + status_total.draft + ')'" name="0" />
      <el-tab-pane
        :label="'已执行待确认 (' + status_total.confirm + ')'"
        name="1"
      />
      <!-- 加的，name与状态无关 -->
      <el-tab-pane
        :label="'未执行 (' + status_total.uncompleted + ')'"
        name="3"
      />
      <el-tab-pane
        :label="'确认完成 (' + status_total.complete + ')'"
        name="2"
      />
      <el-tab-pane :label="'全部 (' + status_total.all_num + ')'" name="9" />
      <el-tab-pane
        v-if="searchForm.is_own === '1'"
        label="与我相关的全部"
        name="10"
      />
    </el-tabs>
    <el-card
      v-for="(item, index) in taskList"
      :key="index"
      class="box-card"
      style="cursor: pointer; margin-bottom: 10px"
    >
      <div slot="header" class="clearfix">
        <span class="them">( 编号：{{ item.meeting_id }} )</span>
        <span class="them">会议主题：{{ item.meeting_subject }}</span>
      </div>
      <div class="amTask">{{ item.task_name }}</div>
      <el-table
        :header-cell-style="{
          background: '#409eff',
          padding: '8px 0',
          color: '#fff',
        }"
        :data="item.task_all"
        :span-method="objectSpanMethod"
        :row-class-name="tableRowClassName"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column label="负责人" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.executor.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="week_task_name" width="220" label="本周重点">
          <template slot-scope="scope">
            <label
              style="font-weight: normal"
              v-html="scope.row.week_task_name"
            />
          </template>
        </el-table-column>
        <el-table-column prop="task_desc" label="今日重点工作" min-width="350">
          <template slot-scope="scope">
            <span v-if="scope.row.task_type === 'day'">
              <label style="font-weight: normal" v-html="scope.row.task_name"
            /></span>
            <span v-else />
          </template>
        </el-table-column>
        <el-table-column prop="confirm" label="确认人" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.confirm.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount3" label="是否执行" width="110">
          <template slot-scope="scope">
            <el-checkbox
              v-if="scope.row.task_status === 0 && activeName === '0'"
              v-model="scope.row.checked"
              :disabled="!scope.row.isMy"
              size="medium"
            />
            <span v-if="activeName !== '0' && scope.row.task_status === 0"
              >草稿</span
            >
            <span v-if="scope.row.task_status === 1">已执行待确认</span>
            <span v-if="scope.row.task_status === 2">确认完成</span>
            <span v-if="scope.row.task_status === 3">未执行</span>
          </template>
        </el-table-column>
        <el-table-column prop="progress" label="执行情况" width="350">
          <template slot-scope="scope">

            <div v-if="activeName==='0' && scope.row.task_status===0">
              <span style="color: red; font-size: 22px; margin: 3px 5px"
                >*</span
              >
              <el-input
                :autosize="{ minRows: 1 }"
                v-model="scope.row.progress1"
                :class="{
                  needText:
                    !scope.row.progress1 &&
                    scope.row.executor.workcode === username,
                }"
                :disabled="!scope.row.isMy"
                type="textarea"
                style="width: 270px"
                placeholder="请输入内容"
              />
              <el-upload
                :file-list="scope.row.fileList"
                :on-success="taskhandleChange"
                :before-remove="beforeRemove"
                :headers="{ Authorization: $store.getters.token }"
                :data="{
                  upload_type: 'attachment',
                  file_type: 'task',
                  relate_id: scope.row.id,
                }"
                :action="BASE_API"
                class="upload-demo"
                style="display: inline"
                multiple
                name="files"
              >
                <i
                  class="el-icon-paperclip"
                  title="上传附件"
                  style="font-size: 20px; margin-left: 5px"
                />
              </el-upload>
            </div>
            <span v-else>
              <span v-html="scope.row.progress" />
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="activeName !== '2'"
          prop="amount3"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              v-if="
                activeName === '0' &&
                scope.row.task_status === 0 &&
                item.meeting_end_time !== '0000-00-00 00:00:00' &&
                scope.row.executor.workcode === username
              "
              size="mini"
              type="success"
              @click="handleEdit(scope.row)"
              >提交</el-button
            >
            <el-button
              v-if="
                activeName === '0' &&
                item.meeting_end_time === '0000-00-00 00:00:00' &&
                scope.row.executor.workcode === username
              "
              size="mini"
              type="success"
              disabled
              title="早会还未结束，不可提交相关任务执行情况"
              >提交</el-button
            >
            <el-button
              v-if="
                activeName === '1' &&
                scope.row.task_status === 1 &&
                scope.row.confirm.workcode === username
              "
              size="mini"
              type="success"
              @click="handleconfirm(scope.row)"
              >确认</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="amount3"
          label="查看进度/附件"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <i
              v-if="activeName !== '3'"
              class="el-icon-document"
              title="进度详情"
              style="fontsize: 20px; marginright: 10%"
              @click="openBox(scope.row)"
            />
            <i
              v-if="activeName !== '3' && scope.row.attachments.length"
              class="el-icon-paperclip"
              title="下载附件"
              style="fontsize: 20px"
              @click="downloadFile(scope.row.attachments)"
            />
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px; text-align: right">
        <el-button
          v-if="
            activeName === '0' &&
            item.task_all.length > 1 &&
            item.meeting_end_time !== '0000-00-00 00:00:00' &&
            item.canSubAll
          "
          size="mini"
          type="success"
          @click="handleEditAll(item.task_all)"
          >一键提交</el-button
        >
        <el-button
          v-if="
            activeName === '0' &&
            item.task_all.length > 1 &&
            item.meeting_end_time === '0000-00-00 00:00:00' &&
            item.canSubAll
          "
          size="mini"
          type="success"
          disabled
          title="早会还未结束，不可提交相关任务执行情况"
          >一键提交</el-button
        >
      </div>
    </el-card>
    <el-card
      v-if="loading === false && taskList.length === 0"
      class="box-card"
      style="margin-top: 10px; min-height: 200px"
    >
      <div style="text-align: center; line-height: 160px">无数据</div>
    </el-card>
    <el-card
      v-loading="loading"
      v-if="loading === true"
      element-loading-text="数据加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0,0,0,0.6)"
      style="margin-top: 10px; min-height: 200px"
    />
    <div style="margin-top: 10px; text-align: center">
      <el-pagination
        :page-sizes="[2, 5, 10, 20]"
        :total="total"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  searchTask,
  getTask,
  getLog,
  taskExecution,
  taskConfirm,
  meetingTaskCount,
  searchAllTask
} from '@/api/morningMeeting'
import { deleteFile } from '@/api/seedetails'

import taskInfo from '../components/taskInfo'
export default {
  components: {
    taskInfo
  },
  data() {
    return {
      loading: false,
      drawer: false,
      searchForm: {
        time: '',
        meeting_name: '',
        meeting_id: null,
        is_own: '1' // 1与我相关早晚会任务
      },
      taskList: [],
      checked: true,
      total: 0,
      page: 1,
      page_size: 2,
      activeName: '0',
      taskData: {},
      activeLabel: '',
      logList: [],
      status_total: {
        all_num: 0,
        complete: 0,
        confirm: 0,
        draft: 0,
        uncompleted: 0
      },
      batchMsg: '', // 记录批量提交的错误信息，一次展示
      needTimes: 0,
      downLen: 0,
      BASE_API: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters(['roles', 'username'])

  },
  created() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    const startTime = this.getDate(start)
    const endTime = this.getDate(end)
    this.$set(this.searchForm, 'time', [startTime, endTime])// 查询最近一个月 日期

    this.searchFormSubmit()
    this.getCount()
    this.BASE_API = `${process.env.VUE_APP_BASE_API}/common/upload`
  },
  methods: {
    getDate(time) { // 格式化时间 为 2020-01-01
      if (time) {
        const val = new Date(time)
        const Y = val.getFullYear()
        const M = (val.getMonth() + 1) < 10 ? '0' + (val.getMonth() + 1) : (val.getMonth() + 1)
        const D = val.getDate() < 10 ? '0' + val.getDate() : val.getDate()
        const h = val.getHours() < 10 ? '0' + val.getHours() : val.getHours()
        const m = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes()
        return Y + '-' + M + '-' + D
      }
      return ''
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        // 只有每组数据的第一个数据的有标识
        return row.nub
          ? { rowspan: row.nub, colspan: 1 }
          : { rowspan: 0, colspan: 0 }
      }
    },
    openBox(row) {
      this.drawer = true
      getTask(row.id)
        .then((res) => {
          this.taskData = res.data.task
        })
        .catch((err) => {
          console.log(err)
        })
      getLog(row.id)
        .then((res) => {
          this.logList = res.data.logs
        })
        .catch((err) => {
          console.log(err)
        })
    },
    submitTask(row, num) {
      // 方便调用，抽离出来
      const params = {
        content: row.progress1,
        is_execution: row.checked ? 1 : 0
      }
      // 是批量的
      if (num) {
        taskExecution(params, row.id)
          .then((res) => {
            this.needTimes--
            if (res.code !== 'success') {
              this.batchMsg = this.batchMsg + '' + params.task_name + ';'
            }
            if (this.needTimes === 0) {
              if (this.batchMsg === '') {
                this.$message.success('提交成功！')
                this.searchFormSubmit()
                this.getCount()
              } else {
                this.$message({
                  type: 'error',
                  messgae: this.batchMsg + '提交任务进度失败！',
                  duration: 3000
                })
                setTimeout(() => {
                  this.searchFormSubmit()
                  this.getCount()
                  this.batchMsg = ''
                  this.needTimes = 0
                }, 1000)
              }
            }
          })
          .catch((err) => {
            this.needTimes--
            console.log(err)
          })
      } else {
        taskExecution(params, row.id)
          .then((res) => {
            if (res.code === 'success') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '已成功!'
              })
              this.searchFormSubmit()
              this.getCount()
            } else {
              this.$message.error('提交任务进度失败！')
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    handleEdit(row) {
      if (row.meeting_end_time === '0000-00-00 00:00:00') {
        this.$message.warning('您的早会还未结束，不能提前填写任务执行情况！')
        return
      }
      if (!row.progress1) {
        this.$message({
          message: '请输入执行情况后提交',
          type: 'warning'
        })
        return false
      }
      this.$confirm('执行情况只能提交一次，是否确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.submitTask(row, false)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消提交'
          })
        })
    },
    handleEditAll(dataItem) {
      // 一键提交的逻辑，遍历草稿会议，找任务状态为0的日任务，取它的checked和 输入内容。调接口提交，页容量不是很大遍历提交应该没多大问题
      this.needTimes = 0
      this.batchMsg = ''
      // 处理提示，多个提交只提示一次
      dataItem.forEach((ele) => {
        if (ele.task_status === 0 && ele.progress1) {
          this.needTimes++
        }
      })
      if (this.needTimes === 0) {
        this.$message.warning('请输入执行情况后提交')
        return
      }
      this.$confirm('执行情况只能提交一次，是否确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          dataItem.forEach((item) => {
            if (item.task_status === 0 && item.progress1) {
              // 如果执行情况为空就不要提交
              this.submitTask(item, true)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    handleconfirm(row) {
      this.$confirm('是否确认完成?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          taskConfirm(row.id)
            .then((res) => {
              this.$message({
                type: 'success',
                message: '已成功!'
              })
              this.searchFormSubmit()
              this.getCount()
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    cancel() {
      this.drawer = false
    },
    handleClick(tab, event) {
      this.taskList = []
      this.page = 1
      this.total = 0
      this.activeName = tab.name
      this.activeLabel = tab.label
      this.getCount()
      if (tab.name === '10') {
        this.searchAll()
      } else {
        this.searchFormSubmit()
      }
    },
    searchAll() {
      const params = {
        meeting_no: this.searchForm.meeting_id,
        workcode: this.username,
        meeting_subject: this.searchForm.meeting_name,
        meeting_start_time: this.searchForm.time
          ? this.searchForm.time[0] + ' 00:00:00'
          : '', // 会议创建 开始时间 如：2019-01-04 00:00:00
        meeting_end_time: this.searchForm.time
          ? this.searchForm.time[1] + ' 23:59:59'
          : '', //	会议创建 结束时间 如 2019-01-05 00:00:00
        page: this.page, //	int// 第几页 默认1
        page_size: this.page_size //	int// 每页总数 默认20
      }
      this.loading = true
      searchAllTask(params)
        .then((res) => {
          this.loading = false
          this.searchResHandle(res, true)
        })
        .catch((err) => {
          this.taskList = []
          this.total = 0
          console.log(err)
          this.loading = false
        })
    },
    searchResHandle(res, isSearchAll) {
      if (res.data.tasks.length) {
        res.data.tasks.forEach((item) => {
          item.canSubAll = false
          item.task_all = []
          item.task.forEach((element) => {
            element.list.forEach((per, index) => {
              if (element.week.length === 0) {
                per.week_task_name = ''
              } else {
                let weekName = ''
                element.week.forEach((x) => {
                  weekName =
                    weekName +
                    '' +
                    x.task_name.replace(/\n/g, '<br/>') +
                    '<br/>'
                })
                per.week_task_name = weekName
              }
              if (element.week.length === 0) {
                per.week_task_desc = ''
              } else {
                let weekDesc = ''
                element.week.forEach((y) => {
                  weekDesc = weekDesc + '' + y.task_desc + '<br/>'
                })
              }
              per.meeting_end_time = item.meeting_end_time
              per.meeting_subject = item.meeting_subject
              // 当列表中有登录人的任务时，显示一键提交按钮
              if (per.executor.workcode === this.username) {
                per.isMy = true
                item.canSubAll = true
              } else {
                per.isMy = false
              }
              per.progress =
                per.progress.length > 0
                  ? per.progress[0].replace(/\n/g, '<br/>')
                  : ''
              if (per.task_name.indexOf('\n') !== -1) {
                per.task_name = per.task_name.replace(/\n/g, '<br/>')
              }
              // searchAll 和searchFormSubmit 处理不一样
              if (isSearchAll) {
                if (per.task_status === 1 || per.task_status === 2) {
                  per.checked = true
                }
                if (per.task_status === 0 || per.task_status === 3) {
                  per.checked = false
                }
              } else {
                if ([0, 1, 2].includes(per.task_status)) {
                  per.checked = true
                }
                if (per.task_status === 3) {
                  per.checked = false
                }
              }
              if (index === 0) {
                per.nub = element.list.length
              }
              per.fileList = []
            })
            item.task_all = item.task_all.concat(element.list)
          })
        })
        this.taskList = res.data.tasks
        this.total = res.data.pagination.total
      } else {
        this.taskList = []
        this.total = 0
      }
    },
    searchFormSubmit() {
      const params = {
        workcode: this.username, // 用户工号
        meeting_subject: this.searchForm.meeting_name, //	string// 会议主题
        is_own: this.searchForm.is_own === '' ? 0 : 1,
        meeting_id: this.searchForm.meeting_id,
        task_status: this.activeName, //	string// 早会状态 0 待确认 1 待确认 2 已执行
        estimate_start_time: this.searchForm.time
          ? this.searchForm.time[0] + ' 00:00:00'
          : '', // 会议创建 开始时间 如：2019-01-04 00:00:00
        estimate_end_time: this.searchForm.time
          ? this.searchForm.time[1] + ' 23:59:59'
          : '', //	会议创建 结束时间 如 2019-01-05 00:00:00
        page: this.page, //	int// 第几页 默认1
        page_size: this.page_size //	int// 每页总数 默认20
      }
      this.loading = true
      searchTask(params)
        .then((res) => {
          this.loading = false
          this.searchResHandle(res, false)
          console.log('新数据s', this.taskList)
        })
        .catch((err) => {
          this.taskList = []
          this.total = 0
          console.log(err)
          this.loading = false
        })
    },
    // 数量统计接口
    getCount() {
      const params = {
        meeting_id: this.searchForm.meeting_id
          ? this.searchForm.meeting_id
          : '',
        meeting_subject: this.searchForm.meeting_name,
        is_own: this.searchForm.is_own === '' ? 0 : 1,
        task_status: this.activeName,
        estimate_start_time: this.searchForm.time
          ? this.searchForm.time[0] + ' 00:00:00'
          : '', // 会议创建 开始时间 如：2019-01-04 00:00:00
        estimate_end_time: this.searchForm.time
          ? this.searchForm.time[1] + ' 23:59:59'
          : '' //	会议创建 结束时间 如 2019-01-05 00:00:00
      }
      meetingTaskCount(params).then((response) => {
        console.log('统计', response)
        if (response.code === 'success') {
          this.status_total = response.data
        }
      })
    },
    searchTap() {
      this.page = 1
      if (this.activeName === '10') {
        this.searchAll()
      } else {
        this.searchFormSubmit()
      }
      this.getCount()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.page = 1
      this.taskList = []
      if (this.activeName === '10') {
        this.searchAll()
      } else {
        this.searchFormSubmit()
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.taskList = []
      if (this.activeName === '10') {
        this.searchAll()
      } else {
        this.searchFormSubmit()
      }
    },
    taskhandleChange(responses, file, fileList) {
      console.log(responses, 'responses')
    },
    async downloadFile(files, num) {
      this.downLen = files.length
      let n = num || 0
      await this.down(files[n].id)
      n++
      if (n < this.downLen) {
        setTimeout(() => {
          this.downloadFile(files, n)
        }, 500)
      }
    },
    async down(id) {
      return new Promise((resolve) => {
        const a = document.createElement('a')
        a.style.display = 'none'
        a.download = `${process.env.VUE_APP_BASE_API}/common/download/` + id
        a.href = `${process.env.VUE_APP_BASE_API}/common/download/` + id
        a.click()
        resolve()
      })
    },
    beforeRemove(file, fileList) {
      deleteFile(file.response.data.attachment[0].id)
        .then((res) => {
          if (res.code === 'success') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            return true
          } else {
            return false
          }
        })
        .catch(() => {
          return false
        })
    }
  }
}
</script>

<style lang="scss">
.mytaskList {
  .amTask {
    font-size: 16px;
    margin-bottom: 15px;
    color: #3a3a3a;
  }

  .taskTip {
    color: #888;
    font-size: 14px;

    .time {
      margin-right: 5px;
    }

    span {
      margin-right: 10px;
    }
  }

  .el-tabs__item.is-active {
    font-weight: 800;
  }
}

.box-card2 {
  margin-bottom: 20px;
  webkit-box-shadow: 0 2px 12px 0 rgba(7, 17, 27, 0.2);
  box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.2) !important;
}

.mytaskList .el-checkbox__inner::after {
  height: 12px;
  width: 7px;
  left: 6px;
}

.mytaskList .el-checkbox__inner {
  width: 25px;
  height: 25px;
  border: 3px solid #409eef;
}

.them {
  font-weight: 700;
  font-size: 14px;
}

.tipMsg {
  line-height: 20px;
  font-size: 14px;
  color: #6d9eeb;
  font-weight: bold;
  margin: 0 0 10px;
}

.needText {
  .el-textarea__inner {
    border-color: #e5310d !important;
  }
}
</style>
